const States = [
  'uttar_pradesh',
  'himachal_pradesh',
  'sikkim',
  'uttarakhand',
  'punjab',
  'haryana',
  'gujarat',
  'rajasthan',
  'bihar',
  'madhya_pradesh',
  'arunachal_pradesh',
  'assam',
  'goa',
  'tamil_nadu',
  'maharashtra',
]

export default States
